"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenTraitsView = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_intl_1 = require("react-intl");
const types_1 = require("@framework/types");
const traits_v5_1 = require("@dzambalaorg/traits-v5");
const TokenTraitsView = props => {
    const { metadata } = props;
    const result = Object.entries(metadata).reduce((memo, [key, value]) => {
        switch (key) {
            // MODULE:DND
            // MODULE:BREEDING
            // MODULE:COLLECTION
            case types_1.TokenMetadata.GENES:
                Object.entries((0, traits_v5_1.decodeTraits)(BigInt(value), traits_v5_1.DND)).forEach(([key, value]) => {
                    Object.assign(memo, { [key.toUpperCase()]: value });
                });
                break;
            case types_1.TokenMetadata.TRAITS:
                Object.entries((0, traits_v5_1.decodeTraits)(BigInt(value), traits_v5_1.DND))
                    .slice(2) // delete sire & matron info from traits
                    .forEach(([key, value]) => {
                    Object.assign(memo, { [key.toUpperCase()]: value });
                });
                break;
            default:
                break;
        }
        return memo;
    }, {});
    return ((0, jsx_runtime_1.jsx)(material_1.Grid, { container: true, children: Object.entries(result).map(([key, value]) => ((0, jsx_runtime_1.jsxs)(material_1.Grid, { container: true, children: [(0, jsx_runtime_1.jsx)(material_1.Grid, { size: { xs: 6 }, children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: `enums.geneName.${key}` }) }), (0, jsx_runtime_1.jsx)(material_1.Grid, { size: { xs: 6 }, children: value })] }, key))) }));
};
exports.TokenTraitsView = TokenTraitsView;
//# sourceMappingURL=traits.js.map